export default __webpack_public_path__ + "static/media/2039.c4e7d739.png";